import useCanDoShop from "../../hooks/useCanDoShop.hook";

interface Props {
  id: string;
  onClick: () => void;
  cap?: ShopCap;
  children: React.ReactNode;
}

export default function OutlineBtn({ id, onClick, cap, children }: Props) {
  const canDo = useCanDoShop(cap);

  return (
    <button
      id={id}
      disabled={!canDo}
      onClick={onClick}
      className="text-white bg-her-dodgerblue px-3 py-1 rounded-md disabled:text-her-lightgray2 disabled:border-her-lightgray2 disabled:bg-white/5 disabled:border"
      type="button"
    >
      {children}
    </button>
  );
}
